import { Tooltip } from 'primereact/tooltip';
import { InputText } from 'primereact/inputtext';
import { InputMask } from "primereact/inputmask";
import { InputNumber } from 'primereact/inputnumber';

import CardSeplag from "../../components/CardSeplag";
import RotuloSeplag from "../../components/RotuloSeplag";
import TableSeplag from "../../components/TableSeplag";

import { Button } from 'primereact/button';
import { ErrorOutline, CheckCircleOutline } from '@material-ui/icons'
import { useEffect, useState, memo } from 'react';

import { buscarPessoaPorNomeMatriculaCpf, validarBeneficiario } from "../../service/ValidaCertidaoLegada";

import './style.css'

const initFiltro = {
  cpf: '',
  nome: "",
  matricula: 0
}

const camposTabela = [
  { nome: "nomePessoa", titulo: "Nome" },
  { nome: "cpfFormatado", titulo: "CPF" },
  { nome: "dataNascimento", titulo: "Data Nascimento" },
  { nome: "nomeMae", titulo: "Nome da Mãe" },
]

const CertidaoViewBeneficiario = ({ certidao, setCertidao }) => {

  const [flagValidacaoBeneficiario, setFlagValidacaoBeneficiario] = useState(false)
  const [servidor, setServidor] = useState(null)
  const [listServidor, setListServidor] = useState([])
  const [filtro, setFiltro] = useState(initFiltro);

  const pesquisar = (parmFiltro) => {

    parmFiltro.cpf = parmFiltro.cpf == "" ? null : parmFiltro.cpf.replace(/[^\w\s]|_/g, "")
    parmFiltro.matricula = parmFiltro.matricula == 0 ? null : parmFiltro.matricula
    parmFiltro.nome = parmFiltro.nome == "" ? null : parmFiltro.nome

    buscarPessoaPorNomeMatriculaCpf(parmFiltro).then(res => {

      if (res.content.length == 1) {
        setServidor(res.content[0])
      } else {
        setServidor(null)
        let dados = res.content.map(item => {
          return {
            ...item,
            id: item.rowId
          }
        })
        setListServidor(dados)
      }
    })
  }

  useEffect(() => {

    setFlagValidacaoBeneficiario(certidao.pessoa != null)

    if (certidao.idenValidaCertidaoLegada) {

      pesquisar({ ...initFiltro, cpf: certidao.numrCpfCs.toString() })
      setFiltro({
        ...initFiltro,
        cpf: certidao.numrCpfCs.toString(),
      })
    }

  }, [certidao])


  const setarFiltro = ({ target }) => {
    setFiltro((old) => {
      return {
        ...old,
        [target.name]: target.value
      }
    })
  }

  function filtrar(event) {
    event.preventDefault()
    pesquisar({ ...filtro });
  }

  function onRowSelect(event) {
    setServidor(event.data)
  }

  function btnValidarBeneficiario() {
    let jsonProps = { ...certidao, pessoa: { ...servidor } }
    validarBeneficiario(jsonProps).then(res => {
      setCertidao(res.validaCertidaoLegada)
      window.$toast.current.show({ severity: 'success', summary: res.mensagem });
    })
  }

  return (

    <CardSeplag cardHeaderClassNames={`${flagValidacaoBeneficiario ? 'div_validado_header' : 'div_naoValidado_header'}`} >
      <div className='p-col-12' style={{ display: 'flex', justifyContent: 'flex-start' }}>
        <h5> <strong>Titular</strong></h5>

        {
          flagValidacaoBeneficiario
            ?
            (<>
              <Tooltip target=".tooltip-icon-success" mouseTrack mouseTrackLeft={10} />
              <CheckCircleOutline className='tooltip-icon-success' style={{ color: '#067406', fontSize: '2rem' }} data-pr-tooltip="Titular Validado" data-pr-position='top' />
            </>)
            :
            (<>
              <Tooltip target=".tooltip-icon-warning" mouseTrack mouseTrackLeft={10} />
              <ErrorOutline className='tooltip-icon-warning' style={{ color: '#e95c09', fontSize: '2rem' }} data-pr-tooltip="Titular não Validado" data-pr-position='top' />
            </>)
        }
      </div>

      <hr className='p-col-12' />

      {
        !flagValidacaoBeneficiario &&
        <>
          <CardSeplag title="Dados do ERP" >
            <CardSeplag >
              <form onSubmit={filtrar} className="p-col-12 p-grid" >

                <RotuloSeplag nome="CPF do Titular" cols="12 3 3" >
                  <InputMask placeholder="CPF" mask="999.999.999-99" name="cpf" value={filtro.cpf} onChange={(e) => setarFiltro(e)} id="input_filtro" />
                </RotuloSeplag>

                <RotuloSeplag nome="Nome do Beneficiário:" cols="12 3 3" >
                  <InputText name="nome" id='nome' value={filtro.nome} style={{ width: '100%' }} onChange={(e) => setarFiltro(e)} />
                </RotuloSeplag>

                <RotuloSeplag nome="Matrícula:" cols="12 2 2" >
                  <InputNumber inputId="matricula" name="matricula" value={filtro.matricula} onValueChange={(e) => setarFiltro(e)} mode="decimal" useGrouping={false} />
                </RotuloSeplag>

                <RotuloSeplag nome="" cols="12 3 3" >
                  <div style={{ display: 'flex', paddingTop: '19px' }}>
                    <Button type='submit' label="Filtrar" icon="pi pi-search" className="p-button-raised" style={{ marginRight: '5px' }} />
                  </div>
                </RotuloSeplag>
              </form>
            </CardSeplag>

            <div className="p-col-12" style={{ marginBottom: '20px' }} />
            {
              servidor ?
                <>
                  <RotuloSeplag nome="Nome do Beneficiário:" cols="12 12 4" >
                    <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
                      {servidor.nomePessoa}
                    </label>
                  </RotuloSeplag>
                  <RotuloSeplag nome="CPF:" cols="12 12 4" >
                    <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
                      {servidor.numrCpf}
                    </label>
                  </RotuloSeplag>

                  <RotuloSeplag nome="RG:" cols="12 12 4" >
                    <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
                      {servidor.numrRg}
                    </label>
                  </RotuloSeplag>
                  <RotuloSeplag nome="Órgão Expedidor do RG:" cols="12 12 4" >
                    <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
                      {servidor.clasOrgaoEmissorRg}
                    </label>
                  </RotuloSeplag>

                  <RotuloSeplag nome="Unidade Federativa (UF):" cols="12 12 4" >
                    <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
                      {servidor.ufRg.siglUf}
                    </label>
                  </RotuloSeplag>

                  <RotuloSeplag nome="Data Emissão:" cols="12 12 4" >
                    <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
                      {servidor.dataEmissaoRg}
                    </label>
                  </RotuloSeplag>

                  <RotuloSeplag nome="Nome da Mãe:" cols="12 12 4" >
                    <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
                      {servidor.nomeMae}
                    </label>
                  </RotuloSeplag>

                  <RotuloSeplag nome="Matrícula:" cols="12 12 4" >
                    <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
                      {servidor.servidor.numrMatricula}
                    </label>
                  </RotuloSeplag>

                  <RotuloSeplag nome="Data de Nascimento:" cols="12 12 4" >
                    <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
                      {servidor.dataNascimento}
                    </label>
                  </RotuloSeplag>
                </>

                :
                <ListaBeneficiario
                  listServidor={listServidor}
                  camposTabela={camposTabela}
                  onRowSelect={onRowSelect}
                />

            }

          </CardSeplag>

          <DadosCertidaoLegado certidao={certidao} />
        </>
      }

      {
        flagValidacaoBeneficiario &&
        <BeneficiarioValidadoView pessoa={certidao.pessoa} />
      }

      {
        !flagValidacaoBeneficiario &&
        <div className="p-col">
          <Button label="Validar Beneficiário" className='p-button-success' icon="pi pi-check" onClick={() => btnValidarBeneficiario()} disabled={servidor == null} />
        </div>
      }

    </CardSeplag>
  )
}


export { CertidaoViewBeneficiario }



const DadosCertidaoLegado = memo(function DadosCertidaoLegado({ certidao }) {

  return (
    <CardSeplag title="Dados da Certidão Legada" >
      <RotuloSeplag nome="Nome do Servidor:" cols="12 12 6" >
        <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
          {certidao.nomeAbreviadoCs}
        </label>
      </RotuloSeplag>
      <RotuloSeplag nome="CPF:" cols="12 12 6" >
        <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
          {certidao.numrCpfCs}
        </label>
      </RotuloSeplag>
      <RotuloSeplag nome="RG:" cols="12 12 6" >
        <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
          {certidao.numrRgCs}
        </label>
      </RotuloSeplag>
      <RotuloSeplag nome="Órgão Expedidor do RG:" cols="12 12 6" >
        <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
          {certidao.siglOrgaoExpRgCs}
        </label>
      </RotuloSeplag>

      <RotuloSeplag nome="Matrícula do Servidor:" cols="12 12 6" >
        <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
          {certidao.numrMatriculaPessoalCs}
        </label>
      </RotuloSeplag>


    </CardSeplag>
  )
})


const BeneficiarioValidadoView = memo(({ pessoa }) => {
  return (
    <>
      <RotuloSeplag nome="Nome do Servidor:" cols="12 12 4" >
        <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
          {pessoa.nomePessoa}
        </label>
      </RotuloSeplag>
      <RotuloSeplag nome="CPF:" cols="12 12 4" >
        <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
          {pessoa.numrCpf}
        </label>
      </RotuloSeplag>

      <RotuloSeplag nome="RG:" cols="12 12 4" >
        <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
          {pessoa.numrRg}
        </label>
      </RotuloSeplag>
      <RotuloSeplag nome="Órgão Expedidor do RG:" cols="12 12 4" >
        <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
          {pessoa.clasOrgaoEmissorRg}
        </label>
      </RotuloSeplag>

      <RotuloSeplag nome="Unidade Federativa (UF):" cols="12 12 4" >
        <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
          {pessoa.ufRg.siglUf}
        </label>
      </RotuloSeplag>

      <RotuloSeplag nome="Data Emissão:" cols="12 12 4" >
        <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
          {pessoa.dataEmissaoRg}
        </label>
      </RotuloSeplag>

      <RotuloSeplag nome="Nome da Mãe:" cols="12 12 4" >
        <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
          {pessoa.nomeMae}
        </label>
      </RotuloSeplag>

      <RotuloSeplag nome="Matrícula do Servidor:" cols="12 12 4" >
        <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
          {pessoa.servidor.numrMatricula}
        </label>
      </RotuloSeplag>

      <RotuloSeplag nome="Data de Nascimento:" cols="12 12 4" >
        <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
          {pessoa.dataNascimento}
        </label>
      </RotuloSeplag>
    </>
  )
})

const ListaBeneficiario = memo(({ listServidor, camposTabela, onRowSelect }) => {

  return <>

    {
      listServidor.length > 0 &&
      <div style={{ backgroundColor: '#2196f3', padding: '5px 10px', borderRadius: '10px' }}>
        <span style={{ fontSize: '14px', fontWeight: 600, color: '#FFF' }}>
          Seleciona o servidor na lista
        </span>
      </div>
    }

    <TableSeplag
      dados={listServidor}
      camposTabela={camposTabela}
      hasCabecalhoDinamic={true}
      onRowSelect={onRowSelect}
      selectionMode="radiobutton"
    />

  </>

})